module.exports = __webpack_public_path__ + "img/pirinola.668cc607.gif";